export const HEADER_AND_FOOTER_HEIGHT = 77;
export const HEADER_HEIGHT = 59;
export const FILE_MANAGER_WIDTH = 590;
export const GLOBAL_NAV_HEIGHT = 44;